export default __webpack_public_path__ + "static/media/webberDesktopApp2.2ec33583.png";